import { getFinancialYearLabels } from "../../brsrFinancialYearLabels";
import {
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  NA_FILL,
  VALUE_FILL,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  addPrinciple2BackLink,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  formatNumber,
  setupPrinciple2DetailSheet,
  writeDataRow,
  hideRowsThrough,
} from "./principle2DetailHelpers.js";

export const SHEET_NAME = "Details of other waste";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 9.1796875,
  E: 28,
  F: 30.7265625,
  G: 30.7265625,
  H: 30.7265625,
  I: 30.7265625,
  J: 30.7265625,
  K: 30.7265625,
  L: 9.1796875,
  M: 9.1796875,
  N: 9.1796875,
};

const SUB_HEADER_ROW = HEADER_ROW + 1;
const TEMPLATE_ROW = 11;
const SPACER_ROW = 12;
const DATA_START_ROW = 13;

export function buildDetailsOfOtherWasteSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  const fy = getFinancialYearLabels(reportingYear);
  const fyCurrent = fy.currentYear ? `FY (${fy.currentYear})` : "FY (Current Financial Year)";
  const fyPrevious = fy.previousYear ? `PY (${fy.previousYear})` : "PY (Previous Financial Year)";
  const colEnd = COL_K;

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd,
    ySplit: 12,
    topLeftCell: "D13",
    lastVisibleCol: 14,
    xSplit: 3,
  });
  addPrinciple2BackLink(ws, colEnd);
  addSheetTitle(ws, colEnd, "Details of other waste");

  applyBorderPattern(ws, HEADER_ROW, COL_D, [
    "-tt-",
    "-tt-",
    "-ttt",
    "-ttt",
    "-ttt",
    "-ttt",
    "-ttt",
    "-ttt",
  ]);
  ws.getRow(HEADER_ROW).height = 29;
  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", {
    font: HEADER_FONT_11,
    fill: NA_FILL,
    bordered: false,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_E, "Name Of Other Waste", {
    font: HEADER_FONT_11,
    fill: NA_FILL,
    bordered: false,
    align: "center",
  });
  ws.mergeCells(HEADER_ROW, COL_F, HEADER_ROW, COL_H);
  setCell(ws, HEADER_ROW, COL_F, fyCurrent, {
    font: HEADER_FONT_11,
    bold: true,
    fill: NA_FILL,
    bordered: false,
    align: "center",
  });
  ws.mergeCells(HEADER_ROW, COL_I, HEADER_ROW, COL_K);
  setCell(ws, HEADER_ROW, COL_I, fyPrevious, {
    font: HEADER_FONT_11,
    bold: true,
    fill: NA_FILL,
    bordered: false,
    align: "center",
  });

  applyBorderPattern(ws, SUB_HEADER_ROW, COL_D, [
    "-ttt",
    "-ttt",
    "tttt",
    "tttt",
    "tttt",
    "tttt",
    "tttt",
    "tttt",
  ]);
  ["Re-Used", "Recycled", "Safely Disposed", "Re-Used", "Recycled", "Safely Disposed"].forEach(
    (label, idx) => {
      setCell(ws, SUB_HEADER_ROW, COL_F + idx, label, {
        font: HEADER_FONT_11,
        fill: NA_FILL,
        bordered: false,
        align: "center",
      });
    }
  );
  ws.mergeCells(HEADER_ROW, COL_D, SUB_HEADER_ROW, COL_D);
  ws.mergeCells(HEADER_ROW, COL_E, SUB_HEADER_ROW, COL_E);
  ws.getCell(SUB_HEADER_ROW, COL_D).fill = NA_FILL;
  ws.getCell(SUB_HEADER_ROW, COL_E).fill = NA_FILL;

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, Array(colEnd - COL_D + 1).fill("tttt"));
  for (let col = COL_D; col <= colEnd; col += 1) {
    const fill = col >= COL_F ? VALUE_FILL : undefined;
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, fill, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 15.5;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, colEnd, { row: SPACER_ROW });

  const packaging = sectionC?.principle2?.leadershipIndicator?.reclaimedProductsAndPackaging || {};
  const current = packaging?.currentFinancialYear?.otherWaste || {};
  const previous = packaging?.previousFinancialYear?.otherWaste || {};
  const row = DATA_START_ROW;

  writeDataRow(ws, row, COL_D, colEnd, [
    { col: COL_D, value: "1", align: "center", fill: undefined, font: BODY_FONT },
    { col: COL_E, value: "Other waste", align: "left", fill: VALUE_FILL },
    { col: COL_F, value: formatNumber(current?.reUsed), align: "center", fill: VALUE_FILL },
    { col: COL_G, value: formatNumber(current?.recycled), align: "center", fill: VALUE_FILL },
    { col: COL_H, value: formatNumber(current?.safelyDisposed), align: "center", fill: VALUE_FILL },
    { col: COL_I, value: formatNumber(previous?.reUsed), align: "center", fill: VALUE_FILL },
    { col: COL_J, value: formatNumber(previous?.recycled), align: "center", fill: VALUE_FILL },
    { col: COL_K, value: formatNumber(previous?.safelyDisposed), align: "center", fill: VALUE_FILL },
  ]);
  ws.getRow(row).height = 15.5;

  hideRowsThrough(ws, 5);
  return ws;
}
